import { CustomHeaderPolicy } from './customHeaderPolicy';
export var tenantPolicy = function tenantPolicy(tenant) {
  var key = 'x-tenant-context';
  return {
    create: function create(nextPolicy, options) {
      return new CustomHeaderPolicy(nextPolicy, options, key, tenant);
    }
  };
};